
// import React from "react";
// import { useTranslation } from "react-i18next";

// const RestaurantOffers = () => {
//   const { t } = useTranslation();

//   return (
//     <section className="mahal-restaurant-offers">
//       <div className="container">

//         {/* HEADING */}
//         <div className="row mb-5">
//           <div className="col-lg-6 m-auto text-center">
//             <h6 className="mahal-pill">
//               {t("restaurantoffers.subtitle")}
//             </h6>

//             <h2 className="mahal-title">
//               {t("restaurantoffers.title1")}{" "}
//               <span>{t("restaurantoffers.title2")}</span>
//             </h2>

//             <p className="mahal-desc">
//               {t("restaurantoffers.desc")}
//             </p>
//           </div>
//         </div>

//         {/* OFFERS */}
//         <div className="row">

//           {/* OFFER 1 */}
//           <div className="col-lg-4 col-md-6 mb-4">
//             <div className="mahal-offer-card">
//               <span className="offer-badge">
//                 {t("restaurantoffers.offer1.badge")}
//               </span>

//               <h4>{t("restaurantoffers.offer1.title")}</h4>

//               <p>{t("restaurantoffers.offer1.desc")}</p>

//               <ul>
//                 <li>✔ {t("restaurantoffers.offer1.li1")}</li>
//                 <li>✔ {t("restaurantoffers.offer1.li2")}</li>
//                 <li>✔ {t("restaurantoffers.offer1.li3")}</li>
//               </ul>

//               <a href="/restaurantoffers" className="mahal-btn-secondary">
//                 {t("restaurantoffers.offer1.btn")}
//               </a>
//             </div>
//           </div>

//           {/* OFFER 2 */}
//           <div className="col-lg-4 col-md-6 mb-4">
//             <div className="mahal-offer-card featured">
//               <span className="offer-badge">
//                 {t("restaurantoffers.offer2.badge")}
//               </span>

//               <h4>{t("restaurantoffers.offer2.title")}</h4>

//               <p>{t("restaurantoffers.offer2.desc")}</p>

//               <ul>
//                 <li>✔ {t("restaurantoffers.offer2.li1")}</li>
//                 <li>✔ {t("restaurantoffers.offer2.li2")}</li>
//                 <li>✔ {t("restaurantoffers.offer2.li3")}</li>
//               </ul>

//               <a href="/Registration" className="mahal-btn-primary">
//                 {t("restaurantoffers.offer2.btn")}
//               </a>
//             </div>
//           </div>

//           {/* OFFER 3 */}
//           <div className="col-lg-4 col-md-6 mb-4">
//             <div className="mahal-offer-card">
//               <span className="offer-badge">
//                 {t("restaurantoffers.offer3.badge")}
//               </span>

//               <h4>{t("restaurantoffers.offer3.title")}</h4>

//               <p>{t("restaurantoffers.offer3.desc")}</p>

//               <ul>
//                 <li>✔ {t("restaurantoffers.offer3.li1")}</li>
//                 <li>✔ {t("restaurantoffers.offer3.li2")}</li>
//                 <li>✔ {t("restaurantoffers.offer3.li3")}</li>
//               </ul>

//               <a href="/RestaurantLogIn" className="mahal-btn-secondary">
//                 {t("restaurantoffers.offer3.btn")}
//               </a>
//             </div>
//           </div>

//         </div>

//         <br />
//         <hr />

//       </div>
//     </section>
//   );
// };

// export default RestaurantOffers;








import React from "react";
import { useTranslation } from "react-i18next";

import {
  FiClock,
  FiStar,
  FiArrowRight,
  FiCheck,
  FiPackage
} from "react-icons/fi";

import { PiBowlFood } from "react-icons/pi";
import { GiMeal } from "react-icons/gi";
import { MdLocalOffer } from "react-icons/md";


const RestaurantOffers = () => {
  const { t } = useTranslation();

  return (
    <section className="mahal-restaurant-offers">
      <div className="container">

        {/* Heading */}
        <div className="row mb-5">
          <div className="col-lg-6 m-auto text-center">

            <h6 className="mahal-pill">
              {t("restaurantoffers.subtitle")}
            </h6>

            <h2 className="mahal-title">
              {t("restaurantoffers.title1")}{" "}
              <span>{t("restaurantoffers.title2")}</span>
            </h2>

            <p className="mahal-desc">
              {t("restaurantoffers.desc")}
            </p>

          </div>
        </div>

        <div className="row g-4">

          {/* Card 1 */}
          <div className="col-lg-4 col-md-6">

            <div className="mahal-offer-card">

              <div className="offer-badge popular">
                <FiClock />
                <span className="popular-text1">
                  {t("restaurantoffers.offer1.badge")}</span>
              </div>

              <div className="offer-icon">
                <PiBowlFood />
              </div>

              <h4>
                {t("restaurantoffers.offer1.title")}
              </h4>

              <p>
                {t("restaurantoffers.offer1.desc")}
              </p>

              <div className="offer-divider"></div>

              <ul className="offer-list">

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer1.li1")}
                </li>

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer1.li2")}
                </li>

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer1.li3")}
                </li>

              </ul>

              <a
                href="/restaurantoffers"
                className="mahal-btn-secondary1 offer-btn"
              >
                {t("restaurantoffers.offer1.btn")}
                <FiArrowRight />
              </a>

            </div>

          </div>

          {/* Card 2 */}

          <div className="col-lg-4 col-md-6">

            <div className="mahal-offer-card featured">

              <div className="offer-badge popular1">
                <FiStar />
                <span className="popular-text">
        {t("restaurantoffers.offer2.badge")}
    </span>
              </div>

              <div className="offer-icon">
               <FiPackage />
              </div>

              <h4>
                {t("restaurantoffers.offer2.title")}
              </h4>

              <p>
                {t("restaurantoffers.offer2.desc")}
              </p>

              <div className="offer-divider"></div>

              <ul className="offer-list">

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer2.li1")}
                </li>

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer2.li2")}
                </li>

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer2.li3")}
                </li>

              </ul>

              <a
                href="/Registration"
                className="mahal-btn-primary offer-btn"
              >
                {t("restaurantoffers.offer2.btn")}
                <FiArrowRight />
              </a>

            </div>

          </div>

          {/* Card 3 */}

          <div className="col-lg-4 col-md-6">

            <div className="mahal-offer-card">

              <div className="offer-badge">
                <MdLocalOffer />
                <span className="popular-text1">{t("restaurantoffers.offer3.badge")}</span>
              </div>

              <div className="offer-icon">
                <GiMeal />
              </div>

              <h4>
                {t("restaurantoffers.offer3.title")}
              </h4>

              <p>
                {t("restaurantoffers.offer3.desc")}
              </p>

              <div className="offer-divider"></div>

              <ul className="offer-list">

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer3.li1")}
                </li>

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer3.li2")}
                </li>

                <li>
                  <span className="check-icon">
                    <FiCheck />
                  </span>

                  {t("restaurantoffers.offer3.li3")}
                </li>

              </ul>

              <a
                href="/RestaurantLogIn"
                className="mahal-btn-secondary1 offer-btn"
              >
                {t("restaurantoffers.offer3.btn")}
                <FiArrowRight />
              </a>

            </div>

          </div>

        </div>

        <hr className="mt-5"/>

      </div>
    </section>
  );
};

export default RestaurantOffers;